import { render, staticRenderFns } from "./DocumentationDetail.vue?vue&type=template&id=fd6110da&scoped=true"
import script from "./DocumentationDetail.vue?vue&type=script&lang=js"
export * from "./DocumentationDetail.vue?vue&type=script&lang=js"
import style0 from "./DocumentationDetail.vue?vue&type=style&index=0&id=fd6110da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6110da",
  null
  
)

export default component.exports